import { Button } from '@chakra-ui/react';
import { faEllipsis } from '@fortawesome/pro-regular-svg-icons';
import { FaIcon } from '../../fa-icon';

export function PageEllipsis() {
    return (
        <Button
            variant="ghost"
            color="muted.100"
            colorScheme="muted"
            isDisabled
            _disabled={{ cursor: 'initial' }}
        >
            <FaIcon icon={faEllipsis} />
        </Button>
    );
}
